import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TariffManagementComponent } from './tariff-management.component';
import { CreateTariffComponent } from './create/create-tariff.component';
import { RouteConstants } from 'src/app/util/route.constants';

const routes: Routes = [
  { path: '', component: TariffManagementComponent, data: RouteConstants.TARIFF_MGMT },
  { path: 'tariff/create', component: CreateTariffComponent, pathMatch: 'full', data: RouteConstants.TARIFF_MGMT_CREATE },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TariffManagementRoutingModule { }
